import type { SxProps, Theme } from "@mui/material/styles";

/** Primary contained action button aligned with brand theme tokens. */
export const brandContainedButtonSx: SxProps<Theme> = {
  bgcolor: "primary.main !important",
  color: "primary.contrastText !important",
  boxShadow: "none",
  textTransform: "none",
  fontWeight: 500,
  height: "32px",
  minHeight: 32,
  px: 1.5,
  borderRadius: "6px",
  "&:hover": {
    bgcolor: "primary.main !important",
    boxShadow: "none",
  },
  "& .MuiButton-startIcon, & .MuiButton-endIcon": {
    color: "inherit !important",
    marginRight: "8px",
  },
};
